import { Box, Button, Tooltip, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { OneSwitch } from '../../Components/OneSwitch/OneSwitch'
import { Ellipsis, PaiEllipsis } from '../../Pages/MonitoramentoPage/CardEvento/SxCardEventos'
import ModalObservacao from './ModalObservacao/ModalObservacao'
import { useContext, useState } from 'react'
import { WebSocketContext } from '../../Providers/WebSocket/WebSocketContext'
import { UserContext } from '../../Providers/UserContext/UserContex'
import { showNotify } from '../../Utils/Utils'

const Entrada = ({
    IconStart,
    nomeEntrada,
    objEntrada,
    id_Central,
    callbackAbrirPorta,
    isDisabled = false
}) => {
    const { user } = useContext(UserContext)
    const { addRoute, sendWsCortex, sendWs } = useContext(WebSocketContext)
    const [manter, setManter] = useState(objEntrada.status_manter == "1")
    const [abrirFechar, setAbrirFechar] = useState(objEntrada.status_sensor == "0")
    const [open, setOpen] = useState(false)
    const [texto, setTexto] = useState('')
    const [obs, setObs] = useState('')

    const getManterCortex = (msg) => {
        let ent = msg.data
        for (let i = 0; i < ent.length; i++) {
            if (ent[i][0] == objEntrada.id) {
                setAbrirFechar(ent[i][1] == "0")
                setManter(ent[i][2] == "1")
                setObs('')
            }
        }
    }

    const getIsDisabled = () => {
        if (typeof isDisabled == "function") {
            return isDisabled()
        } else if (typeof isDisabled == "boolean") {
            return isDisabled
        }
    }

    const sendStatusManter = () => {
        let stat = manter ? 0 : 1
        let tp_aciona = objEntrada.status_sensor == 1 && stat == 1 ? 3 : 2 // 3 para dar um comando p/ abrir a porta antes de manter aberto e 2 para fechar a porta
        sendWsCortex('cmdm', { id: objEntrada.id, usuario: user.id, status: stat, tp: tp_aciona, obs }, id_Central)
        addRoute('ent', getManterCortex)
    }

    const handleManterAberto = (event) => {
        if (event.target.checked) {
            if (objEntrada.id_porta_manter > 0) {
                if (objEntrada.edit_obs_manter_aberto) {
                    setOpen(!open)
                } else {
                    // aqui abre se não tem obs
                    sendStatusManter()
                }
            }
        } else {
            // aqui ele desliga o manter aberto
            sendStatusManter()
        }
    }

    const onClickButton = () => {
        setTexto("")
        sendStatusManter()
        setOpen(!open)
    }

    const ligarParaRamal = () => {
        addRoute('ligarInterfone', getLigarRamal)
        sendWs('ligarInterfone', { id_entrada: objEntrada.id })
    }

    const getLigarRamal = (msg) => {
        let dados = msg.data
        let obj = {
            origin: 'localhost',
            data: {
                cmd: "obsligacaointerfone",
                dados: {
                    status: false,
                    usuario: user.id,
                    nome: user.nome,
                    fone: objEntrada.ramal,
                    tipo: 2,
                    entrada: objEntrada.descricao
                }
            }
        }
        if (dados.status == "error") {
            showNotify('error', dados.message)
        } else {
            if (dados.ligar == "OK") {
                obj.data.dados.status = true
                global.trataIframe(obj)
            } else {
                showNotify("warning", `Erro ao ligar no ramal ${objEntrada.ramal}`)
                global.trataIframe(obj)
            }
        }
    }

    const abrir_fechar_Entradas = () => {
        sendWsCortex('cmdb', { id: objEntrada.id, usuario: user.id }, id_Central)
        addRoute('ent', (msg) => {
            let ent = msg.data

            if (objEntrada.id_porta_rele > 0) {
                for (let i = 0; i < ent.length; i++) {
                    if (ent[i][0] == objEntrada.id) {
                        setAbrirFechar(ent[i][1] == "0")
                    }
                }
            }
        })
        callbackAbrirPorta(objEntrada.id, nomeEntrada)
    }

    const onChangeText = (event) => {
        setTexto(event.target.value)
        setObs(event.target.value)
    }

    return (
        <Grid container mx={ "auto" } p={"5px"} m={0.5} xs={12}
            sx={{
                display: 'flex',
                width: '100%',
                height: '10%',
                background: manter ? '#ec5252' : '#ffffff',
                borderRadius: '5px',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.322)'
            }}
        >
            <Grid gap={3} sx={{ display: 'flex', alignItems: 'center', width: '90%', height: "100%" }} >
                <Grid>
                    {
                        objEntrada.id_porta_rele > 0
                            ? <Button
                                sx={{
                                    background: abrirFechar ? '#FF0000' : '#135c0c',
                                    color: 'white',
                                    borderRadius: '5px',
                                    width: '5rem',
                                    height: '30px',
                                    '&:hover': {
                                        background: '#0FBB00'
                                    },
                                    '&.Mui-disabled': {
                                        color: 'white',
                                        background: '#A9A9A9'
                                    }
                                }}
                                onClick={abrir_fechar_Entradas}
                                disabled={getIsDisabled() || manter}
                            >
                                {abrirFechar ? "Fechar" : "Abrir"}</Button>
                            : <div style={{ width: '5rem', height: '2rem' }}></div>
                    }
                </Grid>
                <Grid sx={{ display: 'flex', alignItems: "center", height: '100%' }}>
                    {
                        objEntrada.ramal == ""
                            ? <div style={{ width: '1rem', height: '2rem' }}></div>
                            : <Tooltip title={`Ligar para ${objEntrada.ramal}`} placement="bottom" arrow>
                                <img
                                    src={IconStart}
                                    onClick={ ligarParaRamal}
                                    style={{ cursor: 'pointer', height: "2rem", width: '1rem' }}
                                ></img>
                            </Tooltip>
                    }

                </Grid>
                <Grid sx={{ color: 'black', ...PaiEllipsis, width: '50%', display: 'flex', alignItems: "center", height: '100%' }}>
                    <Typography sx={ Ellipsis }>{nomeEntrada}</Typography>
                </Grid>
            </Grid>
            <Grid sx={{ display: 'flex', alignItems: "center" }}>
                {
                    objEntrada.id_porta_manter > 0 &&
                        <Tooltip title={ `${(manter ? "Desativar" : "Ativar")} manter aberto`} placement="bottom" arrow>
                            <Box>
                                <OneSwitch
                                    sx={{
                                        width: '40px',
                                        height: '20px',
                                        ...(getIsDisabled() && {
                                            '.MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track': {
                                                backgroundColor: 'grey'
                                            },
                                            '.MuiSwitch-switchBase.Mui-disabled': {
                                                color: 'lightgrey'
                                            }
                                        })
                                    }}
                                    name={"manter-aberto"}
                                    onClick={handleManterAberto}
                                    checked={manter}
                                    disabled={getIsDisabled()}
                                    ball={15}
                                />
                            </Box>
                        </Tooltip>
                }
            </Grid>
            <Grid>
                <ModalObservacao open={open} setOpen={setOpen} onClickButton={onClickButton} texto={texto} onChangeText={onChangeText}></ModalObservacao>
            </Grid>
        </Grid>
    )
}

export default Entrada
